export default {
  filters: [],
  firewalls: [],
  tunnels: [],
  tunnel: null,
  firewall: null,
  setupScript: null,
  activeTunnel: null,
}
